"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PostMessage = require("../api/PostMessage");
var _Button = _interopRequireDefault(require("./Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Tag = _ref => {
  let {
    id,
    className,
    color,
    light,
    size,
    rounded,
    isDelete,
    handleDelete,
    renderAs,
    children
  } = _ref;
  const handleDeleteInternal = idArg => {
    if (typeof handleDelete === 'function') {
      handleDelete(idArg);
      let value = '';
      if (typeof children === 'string') {
        value = children;
      }
      _PostMessage.PostMessage.postMessageCoreEvent('tag-delete-click', {
        className,
        color,
        light,
        size,
        rounded,
        isDelete,
        value
      });
    }
  };
  const RenderAs = renderAs;
  if (isDelete) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: `tag${color ? ` is-${color}` : ''}${light ? ' is-light' : ''}${size ? ` is-${size}` : ''}${rounded ? ' is-rounded' : ''}${isDelete ? ' is-delete' : ''}${color ? ` is-${color}` : ''}${color ? ` is-${color}` : ''}`,
      onClick: () => handleDeleteInternal(id)
    }, children, !isDelete && typeof handleDelete !== 'undefined' && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "delete",
      color: null,
      onClick: () => handleDeleteInternal(id)
    }));
  }
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: `tag${color ? ` is-${color}` : ''}${light ? ' is-light' : ''}${size ? ` is-${size}` : ''}${rounded ? ' is-rounded' : ''}${color ? ` is-${color}` : ''}${color ? ` is-${color}` : ''}`
  }, children, !isDelete && typeof handleDelete !== 'undefined' && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "delete",
    color: null,
    onClick: () => handleDeleteInternal(id)
  }));
};
Tag.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]),
  className: _propTypes.default.string,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'black', 'dark', 'light', 'white']), _propTypes.default.string]),
  light: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'medium', 'large']), _propTypes.default.string]),
  rounded: _propTypes.default.bool,
  isDelete: _propTypes.default.bool,
  handleDelete: _propTypes.default.func,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Tag.defaultProps = {
  renderAs: 'span',
  light: false
};
var _default = exports.default = Tag;
//# sourceMappingURL=Tag.js.map